import { isArray } from 'lodash';

export const concatArraysCustomizer = (objValue, srcValue) => {
  if (isArray(objValue)) {
    return objValue.concat(srcValue);
  }
};
